import ReactGA from 'react-ga4';

export const triggerEvent = (args: any) => ReactGA.event(args);
